import { createSlice } from '@reduxjs/toolkit';
export const initialPortalUserAttributesState = {};
export const portalUserAttributesSlice = createSlice({
  name: 'portalUserAttributes',
  initialState: initialPortalUserAttributesState,
  reducers: {
    updateAttribute: (state, action) => {
      state[action.payload.key] = action.payload.value;
    }
  }
});
export const getPortalUserAttributesState = state => state.portalUserAttributes;
export const {
  updateAttribute
} = portalUserAttributesSlice.actions;
export default portalUserAttributesSlice.reducer;